import { Component, createRef } from "react";
import { IBaseComponentProps, NSBox, NSBoxBooleans, NSBoxInteger, NSRow } from "namirasoft-site-react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { BillWatchProps } from "../BillWatchProps";
import { LookbackPeriodRow } from "namirasoft-bill-watch";

export interface LookbackPeriodLineProps extends IBaseComponentProps, NSARouterMakerResult, BillWatchProps
{
	index: number | null;
	deletable: boolean;
	onDelete: () => void;
	onChanged?: (value: any) => void;
}

interface LookbackPeriodLineState
{
}

export default class LookbackPeriodLine extends Component<LookbackPeriodLineProps, LookbackPeriodLineState>
{
	static WEEKDAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
	static IS_DIRTY(value: LookbackPeriodRow | null): boolean
	{
		if (value)
			if (value.days > 0)
				return true;
		return false;
	}

	private NSBoxInteger_Days = createRef<NSBoxInteger>();
	private NSBoxBooleans_WeekDays = createRef<NSBoxBooleans>();

	constructor(props: LookbackPeriodLineProps)
	{
		super(props);

		this.state = { formula: null };

		this.getValue = this.getValue.bind(this);
		this.isDirty = this.isDirty.bind(this);
		this.onChanged = this.onChanged.bind(this);
	}

	getValue(checkError?: boolean): LookbackPeriodRow
	{
		let days = this.NSBoxInteger_Days.current?.getValue(checkError) ?? 0;
		let weekdays = this.NSBoxBooleans_WeekDays.current?.getValues() ?? [];
		return {
			days,
			mon: weekdays.includes(LookbackPeriodLine.WEEKDAYS[0]),
			tue: weekdays.includes(LookbackPeriodLine.WEEKDAYS[1]),
			wed: weekdays.includes(LookbackPeriodLine.WEEKDAYS[2]),
			thu: weekdays.includes(LookbackPeriodLine.WEEKDAYS[3]),
			fri: weekdays.includes(LookbackPeriodLine.WEEKDAYS[4]),
			sat: weekdays.includes(LookbackPeriodLine.WEEKDAYS[5]),
			sun: weekdays.includes(LookbackPeriodLine.WEEKDAYS[6]),
		}
	}
	setValue(value: LookbackPeriodRow)
	{
		this.NSBoxInteger_Days.current?.setValue(value.days);
		let weekdays = [];
		if (value.mon)
			weekdays.push(LookbackPeriodLine.WEEKDAYS[0]);
		if (value.tue)
			weekdays.push(LookbackPeriodLine.WEEKDAYS[1]);
		if (value.wed)
			weekdays.push(LookbackPeriodLine.WEEKDAYS[2]);
		if (value.thu)
			weekdays.push(LookbackPeriodLine.WEEKDAYS[3]);
		if (value.fri)
			weekdays.push(LookbackPeriodLine.WEEKDAYS[4]);
		if (value.sat)
			weekdays.push(LookbackPeriodLine.WEEKDAYS[5]);
		if (value.sun)
			weekdays.push(LookbackPeriodLine.WEEKDAYS[6]);
		this.NSBoxBooleans_WeekDays.current?.setValues(weekdays);
	}
	isDirty(): boolean
	{
		return LookbackPeriodLine.IS_DIRTY(this.getValue(false));
	}
	private onChanged()
	{
		if (this.props.onChanged)
			this.props.onChanged(this.getValue(false));
	}
	override render()
	{
		return (
			<>
				<NSRow
					style={{
						justifyContent: "start",
						alignItems: "end",
						width: NSBox.width.triple
					}}
				>
					<NSBoxInteger
						ref={this.NSBoxInteger_Days}
						required
						title={`Days ${this.props.index != null ? (this.props.index + 1) : ""}`}
						min={1}
						max={90}
						style={{ width: "150px", alignSelf: "start" }}
						menu={{
							builtin: {
								delete: {
									enabled: this.props.deletable,
									onDelete: () => { this.props.onDelete(); }
								}
							},
							items: []
						}}
						onChanged={this.onChanged}
					/>
					<NSBoxBooleans
						ref={this.NSBoxBooleans_WeekDays}
						items={LookbackPeriodLine.WEEKDAYS.map(d => { return { value: d, text: d } })}
						box_all={{
							hideHeader: true,
							style: { flex: 1 },
							label: { style: { flex: 1, paddingLeft: "0px", paddingRight: "0px", border: "unset !important" } }
						}}
						boxes={{
							hideHeader: true,
							defaultValue: LookbackPeriodLine.WEEKDAYS,
							style: { flex: 1 },
							label: { style: { flex: 1, paddingLeft: "0px", paddingRight: "0px", border: "unset !important" } }
						}}
					></NSBoxBooleans>
				</NSRow>
			</>
		);
	}
}